module.exports = __webpack_public_path__ + "static/media/WWFIcon.057aa545.svg";